import { render } from "./SideNav.vue?vue&type=template&id=eaec6450&scoped=true"
const script = {}

import "./SideNav.vue?vue&type=style&index=0&id=eaec6450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaec6450"]])

export default __exports__